import React, { useContext, useEffect, useState } from "react";
import { ButtonWIcon, SearchInput, TableDropDown } from './Inputs'
import { getStuff } from '../helpers/auth'
import { AlertsContext } from './Layout'
import { authenticatedContext } from '../App'
import { PaginationComponent } from './TablePagination'
import { dateObjToStrDate, convertTimestampToCzech } from '../helpers/date_conversion'
import { useNavigate } from "react-router-dom";
import { DateRange } from 'react-date-range';
import { cs } from 'date-fns/locale';
import { FormatDaysOnProject } from './HelperComponents'
import '../css/table.css'


const Table = ({ headers, actions, reqUrl, redirectOnRecordClick = true, updateShit = false }) => {


    const navigate = useNavigate();
    const addAlertBanner = useContext(AlertsContext);
    const { authenticated, setAuthenticated } = useContext(authenticatedContext);
    const [tableData, setTableData] = useState(null);
    const [activePage, setActivePage] = useState(0);

    useEffect(() => {
        if (reqUrl === "") return;
        getStuff(reqUrl + `/${activePage}`).then((res) => {
            try {
                if (res.status === 200) {
                    console.log(res.data)
                    setTableData(res.data);
                    console.log("table data ", res.data)
                } else if (res.status === 401) {
                    setAuthenticated(false);
                } else {
                    addAlertBanner("Něco se pokazilo", "danger");
                }
            } catch {
                addAlertBanner("Něco se pokazilo", "danger");
            }
        });
    }, [reqUrl, updateShit, activePage])

    if (tableData === null) return (<div style={{ "padding": "5px" }}>Načítám tabulku..</div>)
    return (
        <div className="table-and-actions">
            <div className="record-count">Počet záznamů: <b>{tableData.record_count}</b></div>
            <table className="records-table">
                <thead>
                    <tr rowSpan={2}>
                        {headers.map((header, index) => {
                            return (
                                <th key={index}>
                                    <TableHeader header={header} tableData={tableData} />
                                </th>
                            );
                        })}
                    </tr>

                </thead>
                <tbody>
                    {tableData.data.map((record, index) => {
                        return (
                            <tr key={index} onClick={redirectOnRecordClick ? () => navigate((actions.requestBase + record[actions.recordIdKey])) : null}>
                                {headers.map((header, index) => {
                                    if (header.type === "text") {
                                        return (
                                            <td key={index}>{record[header.dataKey]}</td>
                                        )
                                    } else if (header.type === "category") {
                                        return (
                                            <td key={index} className={header.dataKey == "tags" && "category-flex"}>
                                                {
                                                    (Array.isArray(record[header.dataKey])) ?
                                                        record[header.dataKey].map((category, index) => {
                                                            let style = {}
                                                            let name = category.name
                                                            if (category.color) {
                                                                style = { backgroundColor: category.color }
                                                                name = category.name
                                                            }
                                                            return (<div key={index} className="category" style={style}>{name}</div>)
                                                        })
                                                        : <div className="category">{record[header.dataKey]}</div>

                                                }
                                            </td>
                                        )
                                    } else if (header.type === "bool") {
                                        if (record[header.dataKey] === true) {
                                            return (<td key={index} className="td-center">
                                                <img src="/img/svg/bool_true.svg" alt="true" />
                                            </td>)
                                        } else {
                                            return (<td key={index} className="td-center">
                                            </td>)
                                        }
                                    } else if (header.type === "time") {
                                        return (
                                            <td key={index}>{convertTimestampToCzech(record[header.dataKey], true)}</td>
                                        )
                                    }
                                    else if (header.type === "time_date") {
                                        return (
                                            <td key={index}>{convertTimestampToCzech(record[header.dataKey])}</td>
                                        )
                                    }
                                    else if (header.type === "proj_actions") {
                                        return (
                                            <td key={index}>

                                                <div key={index} className="proj-action">
                                                    {
                                                        getImgEnterLeaveProject(record.linked_from, record.linked_to, actions) &&
                                                        <ButtonWIcon iconSrc={getImgEnterLeaveProject(record.linked_from, record.linked_to, actions)} onClick={
                                                            () => { actions.controls.onEnterLeave(record.project_id, record.linked_from, record.linked_to, record.name, record.days_on_project, false) }
                                                        } />
                                                    }
                                                    {
                                                        record.linked_from &&
                                                        <ButtonWIcon iconSrc={actions.controls.edit_proj_src} onClick={() => {
                                                            actions.controls.onEnterLeave(record.project_id, record.linked_from, record.linked_to, record.name, record.days_on_project, true)
                                                        }
                                                        } />
                                                    }

                                                </div>
                                            </td>
                                        )
                                    }
                                    else if (header.type === "aid_actions") {
                                        return (
                                            <td key={index}>
                                                <div key={index} className="proj-action aid-action">
                                                    <ButtonWIcon iconSrc={actions.controls.deleteSrc} style={{}} onClick={() => {
                                                        actions.controls.onDeletePress(record.aid_record_id)
                                                    }} />
                                                </div>
                                            </td>
                                        )
                                    }
                                    else if (header.type === "app_user_admin") {
                                        return (
                                            <td key={index}>
                                                <div key={index} className="proj-action aid-action">
                                                    <ButtonWIcon iconSrc={actions.controls.deleteSrc} style={{}} onClick={() => {
                                                        actions.controls.onDeletePress(record.id)
                                                    }} />
                                                </div>
                                            </td>
                                        )
                                    }
                                    else if (header.type === "days_on_project") {
                                        return (
                                            <td key={index}>
                                                <FormatDaysOnProject days={record["days_on_project"]} daysSpent={record["days_on_project_spent"]} />
                                            </td>
                                        )
                                    }

                                    else { return (<></>) }

                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {tableData.page_count > 1 &&
                <PaginationComponent pageCount={tableData.page_count} activePage={activePage} setActivePage={setActivePage} />
            }
        </div>
    );
};

const filterImgs = {
    "1": "/img/sort_asc.png",
    "-1": "/img/sort_desc.png",
    "0": "/img/sort_inactive.png"
}
function TableHeader({ header, tableData }) {
    function handleSortClick() {
        if (header.sort.value === 0) {
            header.sort.setValue(1);
        } else if (header.sort.value === 1) {
            header.sort.setValue(-1);
        } else if (header.sort.value === -1) {
            header.sort.setValue(0);
        }
    }
    let options;
    if (header.search && header.type === "category") {
        options = tableData[header.category_options_data_key]
        if (header.dataKey === "tags") {
            options = options.map((option, index) => {
                return ({ id: option.tag_id, label: option.name })
            })
        } else if (header.dataKey === "projects" || header.dataKey === "project_name") {
            options = options.map((option, index) => {
                return ({ id: option.project_id, label: `${option.short_name} - ${option.name}` })
            })
        }
    }
    return (
        <div className='table-header'>
            <div className='row-1' onClick={handleSortClick}>
                <p>{header.name}</p>
                {header.sort &&
                    <div className='img-wrapper'>
                        <img src={filterImgs[header.sort.value.toString()]} alt="sort" />
                    </div>}
            </div>
            {header.search && header.type === "text" &&
                <div className='row-2'>
                    <SearchInput searchInput={header.search.value} setSearchInput={header.search.setValue} />
                </div>

            }
            {header.search && (header.type === "category" || header.type === "category_one") &&

                <TableDropDown selected={header.search.value}
                    setSelected={header.search.setValue}
                    options={options} />
            }{
                header.search && header.type === "time" &&
                <div className='row-2 range-picker-row-2'>
                    <div className="graph-period" onClick={() => (header.search.setDatePickerOpen(!header.search.datePickerOpen))}>
                        <div className="date-text">
                            {header.search.value[0].startDate ? dateObjToStrDate(header.search.value[0].startDate) : " nevybráno "} -{" "}
                            {header.search.value[0].endDate ? dateObjToStrDate(header.search.value[0].endDate) : "nevybráno"}
                        </div>
                        <img
                            src="/img/svg/down_arrow_in_black_circle.svg"
                            alt="down arrow"
                            className="down-arrow"
                            style={header.search.datePickerOpen ? { transform: "rotate(180deg)" } : {}}
                        />
                    </div>
                    <div className="just-placeholder">
                        {header.search.datePickerOpen &&
                            <DateRange className="date-range-picker"
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                months={2}
                                locale={cs}
                                onChange={item => header.search.setValue([item.selection])}
                                ranges={header.search.value}
                                direction="horizontal"
                                disabledDay={(day) => (
                                    day > new Date()
                                )} />
                        }
                    </div>
                </div>
            }
            {!header.search &&
                <div className='empty-header'></div>
            }
        </div>
    );
}
export default Table;


function getImgEnterLeaveProject(link_ts, unlink_ts, actions) {
    if (link_ts && unlink_ts) {
        return false
    } else if (link_ts && !unlink_ts) {
        return actions.controls.leave_proj_src
    }
    else {
        return actions.controls.enter_proj_src
    }
}


